/**
 * UserHub 左メニュー定義
 * id は AdminHub hub-settings.userHubNavVisibility と同期必須
 */

export const HUB_NAV_SECTIONS = [
  {
    id: 'main',
    title: 'メイン',
    items: [
      { id: 'dashboard', label: 'ダッシュボード', path: '/dashboard', icon: 'dashboard' },
      { id: 'modules', label: 'モジュール', path: '/modules', icon: 'modules' },
    ],
  },
  {
    id: 'manage',
    title: '管理',
    items: [
      { id: 'licenses', label: 'ライセンス', path: '/licenses', icon: 'licenses' },
      {
        id: 'billing',
        label: '決済・請求',
        path: '/billing',
        icon: 'billing',
        billingGate: true,
      },
    ],
  },
  {
    id: 'settings',
    title: '設定',
    items: [
      { id: 'account', label: 'アカウント', path: '/settings/account', icon: 'account' },
      { id: 'clinic', label: 'クリニック', path: '/settings/clinic', icon: 'clinic' },
      { id: 'users', label: 'ユーザー管理', path: '/settings/users', icon: 'users' },
      { id: 'integrations', label: 'アプリ連携', path: '/settings/integrations', icon: 'integrations' },
    ],
  },
  {
    id: 'support',
    title: 'サポート',
    hideWhenBetaRestricted: true,
    items: [
      { id: 'contact', label: 'お問い合わせ', path: '/support/contact', icon: 'contact' },
      { id: 'invitation', label: '招待コード', path: '/settings/invitation', icon: 'invitation' },
      {
        id: 'legal',
        label: '規約・ポリシー',
        path: '/support/legal',
        icon: 'legal',
        keepWhenBetaRestricted: true,
      },
    ],
  },
];

export const ALL_HUB_NAV_ITEMS = HUB_NAV_SECTIONS.flatMap((section) => section.items);

export function createDefaultFlatNavVisibility() {
  const map = {};
  for (const item of ALL_HUB_NAV_ITEMS) {
    map[item.id] = true;
  }
  return map;
}

export function normalizeFlatNavVisibility(raw) {
  const defaults = createDefaultFlatNavVisibility();
  if (!raw || typeof raw !== 'object') return defaults;
  const map = { ...defaults };
  for (const id of Object.keys(defaults)) {
    if (typeof raw[id] === 'boolean') {
      map[id] = raw[id];
    }
  }
  return map;
}
